import { Firestore, getFirestore } from 'firebase/firestore';
import { useFirebaseApp } from './useFirebaseApp';
import { useMemo } from 'react';

export const useFirestore = (): Firestore => {
  const firebase = useFirebaseApp();
  return useMemo(() => getFirestore(firebase), [firebase]);
};
